import { AlertDialog } from '@base-ui/react/alert-dialog';
import type { ReactNode } from 'react';
import { useI18n } from '../../i18n/i18n';
import { cn } from '../../lib/cn';
import { Button } from './button';
import { BACKDROP, POPUP } from './dialog';

interface ConfirmDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: ReactNode;
  description?: ReactNode;
  confirmLabel: string;
  /** Разрушительное действие (удаление): красная кнопка подтверждения. */
  danger?: boolean;
  /** Запрос в полёте: кнопка подтверждения выключена, диалог не закрывается. */
  pending?: boolean;
  onConfirm: () => void;
}

/** Подтверждение действия: удалить схему, чат, карточку. Закрывает вызывающий после успеха. */
export function ConfirmDialog({
  open,
  onOpenChange,
  title,
  description,
  confirmLabel,
  danger = false,
  pending = false,
  onConfirm,
}: ConfirmDialogProps) {
  const { t } = useI18n();
  return (
    <AlertDialog.Root open={open} onOpenChange={(next) => !pending && onOpenChange(next)}>
      <AlertDialog.Portal>
        <AlertDialog.Backdrop className={BACKDROP} />
        <AlertDialog.Popup className={cn(POPUP, 'max-w-[400px] gap-3.5 p-6')}>
          <div className="space-y-1">
            <AlertDialog.Title className="text-[15px] font-semibold">{title}</AlertDialog.Title>
            {description !== undefined && (
              <AlertDialog.Description className="text-sm text-muted-foreground">
                {description}
              </AlertDialog.Description>
            )}
          </div>
          <div className="flex gap-2">
            <Button
              variant={danger ? 'destructive' : 'primary'}
              disabled={pending}
              onClick={onConfirm}
            >
              {confirmLabel}
            </Button>
            <AlertDialog.Close
              disabled={pending}
              render={<Button variant="secondary">{t('common.cancel')}</Button>}
            />
          </div>
        </AlertDialog.Popup>
      </AlertDialog.Portal>
    </AlertDialog.Root>
  );
}
